"use strict";

document.addEventListener('DOMContentLoaded', () => {
      const pageTopButton = document.querySelector('.pagetop');
      if (!pageTopButton) return;

      window.addEventListener('scroll', () => {
            // body.homeの場合、3000px以上スクロールしたらページトップボタンを表示する
            // そうじゃない場合は、1000px以上スクロールしたらページトップボタンを表示する
            const scrollThreshold = document.body.classList.contains('home') ? 3000 : 1000;
            if (window.scrollY > scrollThreshold) {
                  pageTopButton.classList.add('is-show');
            } else {
                  pageTopButton.classList.remove('is-show');
            }
      });
});
